<template>
  <div>
    <div class="flex items-center relative">
      <input
        :title="$t('passwordProtect.passwordEnter')"
        :type="showPassword ? 'text' : 'password'"
        :placeholder="$t('passwordProtect.passwordEnter')"
        :aria-label="$t('passwordProtect.password')"
        class="w-full text-body border border-solid border-formBorder rounded-small mb-0 pl-5 pr-16 py-4 placeholder-black placeholder-opacity-100"
        :class="{ 'border-danger outline-danger': passwordStatus.incorrect }"
        v-model="password"
        @keypress.enter="handleSubmit"
        required
      />

      <button
        type="button"
        class="-ml-12 bg-transparent border-none p-0"
        @click="toggleShow"
      >
        <HideIcon
          v-if="showPassword"
          class="block"
        />
        <ViewIcon
          v-else
          class="block"
        />
      </button>
    </div>

    <ValidationError
      :hasError="passwordStatus.incorrect"
      :errorMessage="$t('passwordProtect.passwordIncorrect')"
      :errorAdvice="$t('passwordProtect.passwordIncorrectAdvice')"
    />

    <BaseButton
      :variant="customisedBranding ? 'outline' : 'primary'"
      class="!font-medium !text-body w-full mt-6"
      :disabled="!password"
      :loading="loading"
      @click.native="handleSubmit"
    >
      {{$t('passwordProtect.unlockAndview')}}
    </BaseButton>
  </div>
</template>

<script setup>
import { defineProps, ref } from 'vue'

import BaseButton from '@/components/library/buttons/BaseButton'
import ViewIcon from '@/components/icons/ViewIcon.vue'
import HideIcon from '@/components/icons/HideIcon.vue'
import ValidationError from '@/components/library/ValidationError.vue'

const props = defineProps({
  passwordStatus: Object,
  callback: Function,
  customisedBranding: Boolean
})

const password = ref(null)
const showPassword = ref(false)
function toggleShow () {
  showPassword.value = !showPassword.value
}

const loading = ref(false)
async function handleSubmit () {
  if (loading.value) {
    return
  }

  loading.value = true
  await props.callback(password.value)
  loading.value = false
}
</script>

<style scoped>
::-ms-reveal {
  display: none;
}
</style>
